// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from '../api/apiSlice'

  export const logEventsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getLogEventsList: builder.query<any, any>({
            query: params => {
                return {
                    url: `/ocsp/ocsp-configure`,
                    params: params
                }
            },
            providesTags:['GetLogEventsList'],
        })
  })
})

export const {
useGetLogEventsListQuery
} = logEventsApiSlice;